import { LitElement, css, html } from 'lit';
import '../components/app-nav';
import { property, customElement } from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';

import { styles } from '../styles/shared-styles';
import { resolveRouterPath } from '../router';

@customElement('app-home')
export class AppHome extends LitElement {

  @property() message = 'اكتشف عالم التعلم';
  @property() activeNav = 'home';

  static styles = [
    styles,
    css`
    * {
      box-sizing: border-box;
    }

    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      direction: rtl;
      overflow: hidden;
      background-color: var(--background);
      color: var(--foreground);
      font-family: var(--font-mono);
    }

    main {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: calc(var(--spacing) * 5);
      overflow: hidden;
    }
  `];

  async firstUpdated() {
    console.log('منصة التعلم');
  }

  handleSearch(e: Event) {
    const input = e.target as HTMLInputElement;
    console.log('Search query:', input.value);
  }

  handleNavClick(navItem: string, e: Event) {
    e.preventDefault();
    this.activeNav = navItem;
    if (navItem === 'brainstorm') {
      window.location.href = resolveRouterPath('brainstorm');
    }
  }

  render() {
    return html`
      <main>
        <div class="container-centered">
          <h2 class="heading-hero">${this.message}</h2>
          <p class="text-subtitle">ابدأ رحلتك التعليمية معنا</p>

          <sl-input
            class="input-search"
            placeholder="ابحث عن دورة أو موضوع..."
            size="large"
            clearable
            @sl-input="${this.handleSearch}">
            <sl-icon name="search" slot="prefix"></sl-icon>
          </sl-input>
        </div>
      </main>
    `;
  }
}
